'use client';

import { c as _c } from "react/compiler-runtime";
import { Provider as JotaiProvider } from 'jotai';
import { ThemeProvider } from 'next-themes';
import { Toaster } from '@/components/ui/toast';
import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryProvider } from './query-provider';
type ProvidesProps = {
  children: React.ReactNode;
};
export function Providers(props) {
  const $ = _c(3);
  const {
    children
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Toaster timeout={2500} limit={5} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== children) {
    t1 = <JotaiProvider><QueryProvider><ThemeProvider attribute="class" disableTransitionOnChange={true}><TooltipProvider>{children}{t0}</TooltipProvider></ThemeProvider></QueryProvider></JotaiProvider>;
    $[1] = children;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}